import { PostProperties } from "../types";
import image from "../img/lostGemSpeedyJ.jpg";

const post: PostProperties = {
  id: 44,
  title: "Speedy J - Sullivan Room, NYC (08.02.2008)",
  content: `Jochem George Paap, aka Speedy J, is one of the modern icons of techno music. Known for his legendary releases and as one of the artists who push the boundaries of music forward, Speedy has always managed to stay ahead of the curve.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/speedy-j-sullivan-room-nyc-08",
  category: "Lost Gem",
  translationsBg: {
    content: `Йохем Джордж Паап, известен още като Спийди Джей, е една от съвременните икони на техно музиката. Известен с легендарните си издания и като един от артистите, които разширяват границите на музиката, Спийди винаги е успявал да бъде с една крачка от времето.`,
  },
};

export default post;
